var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z","fill":"#6366F1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5 8.375C11.5 8.65114 11.2761 8.875 11 8.875H5C4.72386 8.875 4.5 8.65114 4.5 8.375V7.625C4.5 7.34886 4.72386 7.125 5 7.125H11C11.2761 7.125 11.5 7.34886 11.5 7.625V8.375Z","fill":"white","key":1})]);
}

Minus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
